const SectionHeader = ({ title, subtitle, className = "", darkMode = false }) => {
  return (
    <div className={className + " px-3 md:px-6 lg:px-8"}>
      <h2
        className={`text-xl font-bold mb-1 ${darkMode ? "text-gray-200" : "text-gray-700"}`}
        style={{ fontFamily: "Feather Bold" }}
      >
        {title}
      </h2>
      {subtitle && (
        <div
          className={`text-sm mb-2 ${darkMode ? "text-gray-400" : "text-gray-500"}`}
          style={{ fontFamily: "DIN Next Rounded" }}
        >
          {subtitle}
        </div>
      )}
      <hr className={`mb-4 ${darkMode ? "border-gray-600" : "border-gray-400"}`} />
    </div>
  );
};

export default SectionHeader;